<template>
  <form class="form" @submit.prevent="onSubmit()">
    <FormGroup :v="v$.code" label="discount.label">
      <TextField
        v-model="formValue.code"
        :disabled="props.saving"
        :autocomplete="null"
        placeholder="placeholder.default"
      />
    </FormGroup>

    <AppButton type="submit" :loading="props.saving">
      {{ $t("discount.submit") }}
    </AppButton>
  </form>
</template>

<script setup lang="ts">
import { computed, reactive } from "vue";
import AppButton from "@/components/app-button.vue";
import FormGroup from "@/components/form/form-group.vue";
import TextField from "@/components/form/text-field.vue";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { Discount } from "@/types";

const props = defineProps<{
  discounts: Discount[];
  saving?: boolean;
  errors?: Record<string, string[]>;
}>();

const emit = defineEmits<{
  (e: "submit", code: string): void;
}>();

const formValue = reactive({
  code: "",
});

const uniqueCode = (value: string) =>
  props.discounts.every((d) => d.code !== value);

const rules = computed(() => ({
  code: {
    required,
    uniqueCode,
  },
}));

const v$ = useVuelidate(rules, formValue, {
  $externalResults: computed(() => props.errors),
});

const onSubmit = () => {
  v$.value.$touch();

  if (!v$.value.$invalid) {
    emit("submit", formValue.code);
  }
};
</script>
